/**
 * @generated SignedSource<<05750f810b2a78f4222ef738b746df8c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MentionCountSubscription",
    "kind": "LinkedField",
    "name": "mentionCount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "count",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "InboxQuery_mentionCountSubscription",
    "selections": (v0/*: any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "InboxQuery_mentionCountSubscription",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "c7d2d826c463da261f9e0c53a6e5cb27",
    "id": null,
    "metadata": {},
    "name": "InboxQuery_mentionCountSubscription",
    "operationKind": "subscription",
    "text": "subscription InboxQuery_mentionCountSubscription {\n  mentionCount {\n    count\n  }\n}\n"
  }
};
})();

node.hash = "3c59da2c7a21402de89286a0187732d4";

module.exports = node;
